import { inject, injectable } from "inversify";
import { DocumentSubTypeModel, ICPLDocumentSubTypesClient } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IDocumentSubTypesService {
  getDocumentSubTypes(): Promise<DocumentSubTypeModel[]>;
  createDocumentSubType(name: string, documentTypeID: number): Promise<void>;
  updateDocumentSubType(documentSubTypeModel: DocumentSubTypeModel): Promise<void>;
  deleteDocumentSubType(documentSubTypeID: number): Promise<void>;
}

@injectable()
export class DocumentSubTypesService implements IDocumentSubTypesService {
  @inject(SERVICE_TYPES.CPLDocumentSubTypesClient)
  cplDocumentSubTypesClient!: ICPLDocumentSubTypesClient;

  async getDocumentSubTypes(): Promise<DocumentSubTypeModel[]> {
    return this.cplDocumentSubTypesClient.getDocumentSubTypes();
  }

  async createDocumentSubType(name: string, documentTypeID: number): Promise<void> {
    return this.cplDocumentSubTypesClient.createDocumentSubType(name, documentTypeID);
  }

  async updateDocumentSubType(documentSubTypeModel: DocumentSubTypeModel): Promise<void> {
    return this.cplDocumentSubTypesClient.updateDocumentSubType(documentSubTypeModel);
  }

  async deleteDocumentSubType(documentSubTypeID: number): Promise<void> {
    return this.cplDocumentSubTypesClient.deleteDocumentSubType(documentSubTypeID);
  }
}
